import appCfg from "../../config";

var initializeInterceptors = function(axiosInstance) {
    axiosInstance.interceptors.request.use(
        config => {
            console.log(config.method + " request: " + config.url);
            return config;
        },
        error => {
            console.log(error);
            if (error.code === "ECONNABORTED") {
                console.error("Timeout error code: " + error.code);
            }
            throw error;
        }
    );

    axiosInstance.interceptors.response.use(
        response => {
            console.log(response);
            return response;
        },
        error => {
            console.log(error);
            if (error.code === "ECONNABORTED") {
                console.error("Timeout error code: " + error.code);
            }
            throw error;
        }
    );
};

var postRequest = function(axiosInstance, url, body, config, useBaseServer = false) {
    return axiosInstance
        .post(useBaseServer ? url : appCfg.serverBaseUri + url, body, config)
        .then(function(response) {
            if (response && "data" in response && response.data) {
                return response.data;
            }
            return response;
        })
        .catch(function(error) {
            console.error(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error(error.message);
            }
            console.log(error.config);
            return Promise.reject(error);
        });
};

var patchRequest = function(axiosInstance, url, body, config, useBaseServer = false) {
    return axiosInstance
        .patch(useBaseServer ? url : appCfg.serverBaseUri + url, body, config)
        .then(function(response) {
            if (response && "data" in response && response.data) {
                return response.data;
            }
            return response;
        })
        .catch(function(error) {
            console.error(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error(error.message);
            }
            console.log(error.config);
            return Promise.reject(error);
        });
};

var getRequest = function(axiosInstance, url, useBaseServer = false) {
    return axiosInstance
        .get(useBaseServer ? url : appCfg.serverBaseUri + url)
        .then(function(response) {
            if (response && "data" in response && response.data) {
                return response.data;
            }
            return response;
        })
        .catch(function(error) {
            console.error(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error(error.message);
            }
            console.log(error.config);
            return Promise.reject(error);
        });
};

var deleteRequest = function(axiosInstance, url, body, useBaseServer = false) {
    return axiosInstance
        .delete(useBaseServer ? url : appCfg.serverBaseUri + url, {
            data: body
        })
        .then(function(response) {
            if (response && "data" in response && response.data) {
                return response.data;
            }
            return response;
        })
        .catch(function(error) {
            console.error(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error(error.message);
            }
            console.log(error.config);
            return Promise.reject(error);
        });
};

export default {
    initializeInterceptors,
    getRequest,
    postRequest,
    patchRequest,
    deleteRequest
};
